"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _background = _interopRequireDefault(require("../background"));

var _container = _interopRequireDefault(require("../container"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  backgroundColor: _propTypes.string,
  backgroundImage: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.string), _propTypes.string]),
  boxShadow: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.number), _propTypes.number]),
  children: _propTypes.node,
  className: _propTypes.string,
  containerProps: (0, _propTypes.shape)({
    px: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.array])
  }),
  "data-test-id": _propTypes.string,
  htmlId: _propTypes.string
};

var Section = function Section(_ref) {
  var backgroundColor = _ref.backgroundColor,
      backgroundImage = _ref.backgroundImage,
      boxShadow = _ref.boxShadow,
      className = _ref.className,
      children = _ref.children,
      containerProps = _ref.containerProps,
      dataTestId = _ref["data-test-id"],
      htmlId = _ref.htmlId;
  return /*#__PURE__*/_react["default"].createElement(_background["default"], {
    as: "section",
    backgroundColor: backgroundColor,
    backgroundImage: backgroundImage,
    boxShadow: boxShadow,
    className: className,
    "data-test-id": dataTestId,
    id: htmlId,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_container["default"], containerProps, children));
};

Section.propTypes = propTypes;
Section.displayName = "Modules.Section";
var _default = Section;
exports["default"] = _default;